// Global
import { tv } from 'tailwind-variants';

// Tailwind variables
export const tailwindVariants = tv({
  slots: {
    componentBG: [],
    base: [
      'flex',
      'flex-col',
      'gap-2',
      'items-start',
      'justify-start',
      'relative',
      'overflow-hidden',
      'md:py-spacing-padding-large-6',
      'py-themes-general-surface-spacing-small-padding-y',
      'md:px-themes-general-surface-spacing-large-padding-x',
      'px-themes-general-surface-spacing-small-padding-x',
      'gap-0',
      'shrink-0',
    ],
    contentWrapper: [
      'flex',
      'flex-col',
      'gap-components-heading-page-title-spacing-large-title-margin-bottom',
      'items-start',
      'justify-start',
      'self-stretch',
      'relative',
    ],
    headlineText: [
      'font-header-small-large',
      'leading-header-small-large',
      'text-header-small-large',
      'md:font-header-large-large',
      'md:leading-header-large-large',
      'md:text-header-large-large',
    ],
    description: [
      'font-bodySans-medium',
      'leading-bodySans-medium',
      'text-bodySans-medium',
      'md:font-bodySans-large',
      'md:leading-bodySans-large',
      'md:text-bodySans-large',
    ],
    textAlignment: [
      'flex',
      'flex-col',
      'md:gap-themes-general-surface-spacing-large-title-margin-bottom',
      'gap-themes-general-surface-spacing-small-title-margin-bottom',
    ],
  },
  variants: {
    alignment: {
      Center: {
        contentWrapper: ['items-center'],
        textAlignment: ['w-full', 'text-center'],
      },
      Left: {
        contentWrapper: ['items-start', 'rtl:items-end'],
        textAlignment: ['w-full', 'md:text-left', 'rtl:md:text-right'],
      },
    },
    background: {
      BrandColor: {
        componentBG: ['bg-components-heading-page-title-color-color-bg'],
        description: ['text-components-heading-page-title-color-color-body'],
        headlineText: ['text-components-heading-page-title-color-color-title'],
      },
      Default: {
        componentBG: ['bg-components-heading-page-title-color-default-bg'],
        description: ['text-components-heading-page-title-color-default-body'],
        headlineText: ['text-components-heading-page-title-color-default-title'],
      },
      Light: {
        componentBG: ['bg-components-heading-page-title-color-light-bg'],
        description: ['text-components-heading-page-title-color-light-body'],
        headlineText: ['text-components-heading-page-title-color-light-title'],
      },
    },
  },
});
